import Api from '../../api/Api'
import { isRecertBatch, RECERT_LABEL } from '@/utils/batch'

const workshop = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    workshop: [],
    workshop_popular: [],
    empty: '',
    info: {},
    enrolled: [],
    table_enrolled: [],
    batch_register: [],
    select_batch_register: [],
    table_tanggal_batch: [],
    edit: [],
    materiEvent: [],
    table_interest: [],
    table_interest_all: [],
    pesertaKuis: {
      selected: [],
      header: [
        { text: 'Nama Pelanggan', value: 'fullname', sortable: true },
        { text: 'Jumlah Percobaan', value: 'countTest', sortable: true },
        { text: 'Pre Test', value: 'nilaiPre', sortable: true },
        { text: 'Post Test', value: 'nilaiPost', sortable: true },
        { text: 'Nilai Study Kasus', value: 'nilaiStudi', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'File Studi Kasus', value: 'fileStudi', sortable: true },
        { text: 'Action', value: 'action', sortable: true },
      ],
      list: [],
      isLoading: false,
    },
  },

  //mutations
  mutations: {
    SET_PESERTAKUIS(state, res) {
      state.pesertaKuis.list = res
    },
    SET_WORKSHOP(state, workshop) {
      state.workshop = workshop
    },
    SET_WORKSHOP_POPULAR(state, workshop) {
      state.workshop_popular = workshop
    },
    SET_INFO(state, workshop) {
      state.info = workshop
    },
    SET_EDIT(state, edit) {
      state.edit = edit
      state.materiEvent = edit.materi
    },
    SET_ENROLLED(state, workshop) {
      var temp = []
      workshop.forEach((el) => {
        let data = {
          id_aktifitas: el.id_aktifitas,
          fullname: el.fullname,
          batch: el.batch,
          sertifikat: el.is_sertifikat,
          materi: el.is_materi,
          nohp: el.telepone,
          avatar: el.avatar,
          id: el.id_aktifitas,
          jumlah_percobaan: el.count_test,
          post_test: el.post_test,
          tanggal: el.tgl_kumpul,
          studi_kasus: el.url_periksa,
          status: el.status_study,
          color: el.color_study,
          deadline: el.deadline_trainer_nilai,
          today: el.today,
        }
        temp.push(data)
      })

      state.enrolled = workshop
      state.table_enrolled = temp
    },
    SET_INTERESTED(state, data) {
      var temp = []
      data.forEach((el) => {
        let data = {
          id: el.id,
          avatar: null,
          fullname: el.fullname,
          email: el.email,
          telepone: el.telepone,
          tanggal: el.created_at,
        }
        temp.push(data)
      })

      state.table_interest = temp
    },
    SET_INTERESTED_ALL(state, data) {
      var temp = []
      data.forEach((el) => {
        let data = {
          id: el.id,
          avatar: null,
          fullname: el.fullname,
          email: el.email,
          nohp: el.telepone,
          event: el.judul,
          tanggal: el.created_at,
        }
        temp.push(data)
      })

      state.table_interest_all = temp
    },
    SET_TANGGAL_BATCH(state, workshop) {
      var temp = []
      workshop.forEach((el) => {
        let data = {
          urutan: 'sertifikat kehadiran ' + el.urutan,
          tanggal: el.tanggal,
          jam_mulai: el.jam_mulai,
          jam_selesai: el.jam_selesai,
          status: el.status,
          id: el.id_master_event_tanggal,
        }
        temp.push(data)
      })

      state.table_tanggal_batch = temp
    },
    SET_BATCH_REGISTER(state, batch) {
      var temp = []
      batch.forEach((el) => {
        let data = {
          label: isRecertBatch(el.batch) ? RECERT_LABEL : el.batch,
          value: el.id,
        }
        temp.push(data)
      })

      state.batch_register = batch
      state.select_batch_register = temp
    },
    EMPTY(state, string) {
      state.empty = string
    },
  },

  //actions
  actions: {
    create_workshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('workshop', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    onoffsertifikat({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('workshop/onoffsertifikat', params)
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updatenew({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('workshop/update-new', params)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    create_new({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('workshop/create-new', params)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_new({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('workshop/update-new', params)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    destroy({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/delete/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deactived({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/deactived/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    analytic({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/analytic?id_event=${params.id_event}&id_batch=${params.id_batch}&_id_batch=${params._id_batch}`,
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    async getPesertaKuis({ commit, state }, params) {
      state.pesertaKuis.isLoading = true

      try {
        const response = await Api.get(
          `workshop/get-peserta?id_event=${params.eventId}&search=${params.search}&id_batch=${params.batchId}&page=${params.page}&per_page=${params.per_page}`,
        )

        commit('SET_PESERTAKUIS', response.data.data.data)
        return response.data.data
      } catch (error) {
        throw error
      } finally {
        state.pesertaKuis.isLoading = false
      }
    },
    admin_faq({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`faq/faq_admin_workshop`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    overview({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/overview?id=${params.id}&id_batch=${params.id_batch}&per_page_transaksi=${params.per_page_transaksi}&page_transaksi=${params.page_transaksi}&status_transaksi=${params.status_transaksi}&start_transaksi=${params.start_transaksi}&end_transaksi=${params.end_transaksi}&search_transaksi=${params.search_transaksi}`,
        )
          .then((response) => {
            commit('SET_INFO', response.data.data.info)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    Enrolled({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/enrolled?id=${params.id}&id_batch=${params.id_batch}&per_page=${params.per_page}&page=${params.page}&status_sertifikasi=${params.status_sertifikasi}&search=${params.search}`,
        )
          .then((response) => {
            commit('SET_ENROLLED', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    surveyWorkshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/survey_workshop?id=${params.id}&id_batch=${params.id_batch}&per_page=${params.per_page}&page=${params.page}&search=${params.search}`,
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    edit_general_workshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`workshop/detail/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    actived({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/actived/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    fixAbsensi({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`utility/addAbsensiError`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getEdit({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`workshop/edit/${params.id}`)
          .then((response) => {
            commit('SET_EDIT', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    TanggalSertifikat({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/tanggal_batch?id=${params.id}&id_batch=${params.id_batch}&page=${params.page || 1}&per_page=${params.per_page || 10}`,
        )
          .then((response) => {
            commit('SET_TANGGAL_BATCH', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    waitinglist({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/waiting_list?id=${params.id}&search=${params.search}&tanggal_mulai=${params.tanggal_mulai}&tanggal_selesai=${params.tanggal_selesai}&page=${params.page || 1}&per_page=${params.per_page || 10}`,
        )
          .then((response) => {
            commit('SET_INTERESTED', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getWaitingListAll({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop/waiting_list/all?search=${params.search}&tanggal_mulai=${params.tanggal_mulai}&tanggal_selesai=${params.tanggal_selesai}&page=${params.page}&per_page=${params.per_page}`,
        )
          .then((response) => {
            commit('SET_INTERESTED_ALL', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapusWaiting({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/waiting_list/deleted/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data.message)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail_landing({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`get_mini_workshop/${params.id}`)
          .then((response) => {
            commit('SET_BATCH_REGISTER', response.data.data.batch)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    workshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `workshop?page=${params.page}&per_page=${params.per_page}&status=${params.status}&start=${params.start}&end=${params.end}&search=${params.search}&topik=${params.topik}`,
        )
          .then((response) => {
            commit('SET_WORKSHOP', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    create_workshop_general({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/create_workshop_general`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_userview({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/update_userview`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/update`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update2({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/update2`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    change_absen({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/aturAbsen`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_tanggal({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/hapusTanggalBatch/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_tanggal({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/updateTanggalBatch/${params.id}`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addFavoritWorkshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/set-favorite`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    workshop_rekomendasi({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`workshop/workshop_rekomendasi`)
          .then((response) => {
            commit('SET_WORKSHOP_POPULAR', response.data.landing)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_jam({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`workshop/updateJamBatch/${params.id}`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail_tanggal({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`workshop/detail_tanggal/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    edit_userview_workshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`workshop/detail_userview/${params.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_workshop_transaction({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/workshop/export_transaksi_workshop?id=${params.id}&id_batch=${params.id_batch}&per_page_transaksi=${params.per_page_transaksi}&page_transaksi=${params.page_transaksi}&status_transaksi=${params.status_transaksi}&start_transaksi=${params.start_transaksi}&end_transaksi=${params.end_transaksi}&search_transaksi=${params.search_transaksi}&selected=${params.selected}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_waiting_list_all({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/workshop/export_waiting_list_all?selected=${params.selected}&tanggal_mulai=${params.tanggal_mulai}&tanggal_selesai=${params.tanggal_selesai}&search=${params.search}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_workshop_survey({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/workshop/export_enrolled_survey?id=${params.id}&id_batch=${params.id_batch}&search=${params.search}&selected=${params.selected}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_workshop_enrolled({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/workshop/export_enrolled_workshop?id=${params.id}&id_batch=${params.id_batch}&status_sertifikasi=${params.status_sertifikasi}&search=${params.search}&selected=${params.selected}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_workshop_waiting({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/workshop/export_enrolled_waiting?id=${params.id}&search=${params.search}&tanggal_mulai=${params.tanggal_mulai}&tanggal_selesai=${params.tanggal_selesai}&selected=${params.selected}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getWorkshop(state) {
      return state.workshop
    },
    getInfo(state) {
      return state.info
    },
    getEnrolled(state) {
      return state.enrolled
    },
    getBatchRegister(state) {
      return state.batch_register
    },
    getSelectBatchRegister(state) {
      return state.select_batch_register
    },
    getTableEnrolled(state) {
      return state.table_enrolled
    },
    getTableTanggalBatch(state) {
      return state.table_tanggal_batch
    },
    getEdit(state) {
      return state.edit
    },
    getMateriEvent(state) {
      return state.materiEvent
    },
    getTableInterested(state) {
      return state.table_interest
    },
    getTableInterestedAll(state) {
      return state.table_interest_all
    },
    getWorkshopPopular(state) {
      return state.workshop_popular
    },
    listPesertaKuis(state) {
      return state.pesertaKuis.list
    },
  },
}

export default workshop
